import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_APP016_Request,
  IAPI_APP016_Response,
  IAPI_CON005_Request,
  IAPI_CON005_Response,
} from "../../../type/apiType";

//「俸給の調整額」対象手当参照
const httpAPI_CON005 = async (
  param: IAPI_CON005_Request
): Promise<IAPI_CON005_Response> => {
  let res = await http.post(ApiUrl.API_CON005, {
    ...param,
  });

  return res.data;
};

// 申請状況更新
const httpAPI_APP016 = async (
  param: IAPI_APP016_Request
): Promise<IAPI_APP016_Response> => {
  let res = await http.post(ApiUrl.API_APP016, {
    ...param,
  });

  return res.data;
};

export { httpAPI_CON005, httpAPI_APP016 };
